// useLegacyPortal — the component-facing door to the legacy participant portal.
// Components never import a portal URL: they ask for a route KEY and get a handler
// (and, for real anchors, an href). See config/legacyPortal.js for the route map.
import { useMemo } from 'react';
import { buildLegacyUrl, openLegacy } from '../utils/legacyPortal';

export function useLegacyPortal() {
  return useMemo(() => ({
    /** Click handler: `onClick={() => openLegacy('contributions')}`. */
    openLegacy,
    /** href for a real <a> (keeps middle-click / "open in new tab" working). */
    legacyHref: buildLegacyUrl,
  }), []);
}

export default useLegacyPortal;
